export default __webpack_public_path__ + "static/media/mandymant.b771ba5c.jpg";